import { FC, ReactNode } from 'react';
import { Slottable } from '@radix-ui/react-slot';
import './NavBar.css';

export type NavSlotConfig = { [key: string]: ReactNode };

export type NavBarComponentConfig = {
  name: string;
  Component: FC<any>;
  options: { [key: string]: any };
};

export type NavBarChildrenProps = {
  hidden?: boolean;
  components?: NavBarComponentConfig[];
  children?: ReactNode[] | ReactNode;
};

export type NavBarProps = {
  slotConfig?: NavSlotConfig;
  hidden?: boolean;
  children?: ReactNode[] | ReactNode;
};

function NavBarChildren(props: NavBarChildrenProps) {
  const { hidden, components, children } = props;
  return (
    <Slottable>
      {children}
      {components !== null &&
        Array.isArray(components) &&
        components?.length > 0 &&
        components.map(({ name, Component, options }) => (
          <Component
            key={name}
            hidden={hidden}
            aria-hidden={hidden}
            {...options}
          />
        ))}
    </Slottable>
  );
}

NavBarChildren.defaultProps = {
  hidden: false,
  components: [],
  children: undefined,
};

function NavBar(props: NavBarProps) {
  const { hidden, slotConfig } = props;
  return (
    <nav className={`nav-bar nav-bar--top`}>
      <NavBarChildren hidden={hidden}>{slotConfig?.root}</NavBarChildren>
      <div hidden={hidden} aria-hidden={hidden} id="nav-bar-row">
        <NavBarChildren hidden={hidden}>{slotConfig?.row}</NavBarChildren>
      </div>
    </nav>
  );
}

NavBar.defaultProps = {
  slotConfig: {},
  hidden: false,
  children: undefined,
};

export { NavBar };
